export default function iconTemplate(icon) {
    return ({ className }) => <div className={className}>{icon}</div>;
}
